module.exports = __webpack_public_path__ + "static/img/qrcode.c963706.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/qrcode.png
// module id = Nm7F
// module chunks = 82